export default function IconBedUltimate() {
	return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Hotel-Double-Bed-2--Streamline-Ultimate" height="100%" width="100%">
			<desc>{'\n    Hotel Double Bed 2 Streamline Icon: https://streamlinehq.com\n  '}</desc>
			<path
				d="m19.473 4.5 2.027 0 2 12 -23 0 2 -12 2.278 0"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="M23.5 16.5V21a1.5 1.5 0 0 1 -1.5 1.5H2A1.5 1.5 0 0 1 0.5 21v-4.5"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path d="m1.833 8.5 20.334 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path
				d="M10.552 6.01a0.5 0.5 0 0 1 -0.5 0.49H5.074a0.5 0.5 0 0 1 -0.5 -0.569l0.278 -2a0.5 0.5 0 0 1 0.5 -0.431h4.742a0.5 0.5 0 0 1 0.5 0.51Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="M13.7 6.01a0.5 0.5 0 0 0 0.5 0.49h4.977a0.5 0.5 0 0 0 0.5 -0.569l-0.278 -2A0.5 0.5 0 0 0 18.9 3.5h-4.743a0.5 0.5 0 0 0 -0.5 0.51Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="M2.5 4.5V2A1.5 1.5 0 0 1 4 0.5h16A1.5 1.5 0 0 1 21.5 2v2.5"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path d="m3.5 22.5 0 1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path d="m20.5 22.5 0 1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path d="m10.605 4.614 3.042 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
		</svg>
	);
}
